import { useState } from 'react';
import Dropdown from './Dropdown';
import ResponsiveNavLink from './ResponsiveNavLink';
import AuthImage from './AuthImage';
import FlyOutMenu from './FlyOutMenu';
import { Link } from '@inertiajs/react';

const NavBar = ({ user, header }) => {
    const [showingNavigationDropdown, setShowingNavigationDropdown] = useState(false);
  return (
    <nav className="bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 lg:px-0">
            <div className="flex justify-between h-16 lg:h-24">
                <div className="flex">
                    <div className="shrink-0 flex items-center">
                        <Link href="/">
                            <AuthImage isLogo={true} className="block h-12 lg:h-16 w-auto rounded-full"/>
                        </Link>
                    </div>

                    <div className="space-x-8 sm:-my-px sm:ml-10 sm:flex">
                        <FlyOutMenu header={header} />
                    </div>
                </div>

                <div className="hidden sm:flex sm:items-center sm:ml-6">
                    <div className="ml-3 relative">
                        <Dropdown>
                            <Dropdown.Trigger>
                                <span className="inline-flex rounded-md">
                                    <button
                                        type="button"
                                        className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-slate-500 bg-white hover:text-slate-700 focus:outline-none transition ease-in-out duration-150"
                                    >
                                        {user.name}

                                        <svg
                                            className="ml-2 -mr-0.5 h-4 w-4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </Dropdown.Trigger>

                            <Dropdown.Content>
                                <Dropdown.Link href={route('profile.edit')}>Profile</Dropdown.Link>
                                <Dropdown.Link href={route('signout')} method="post" as="button">
                                    Log Out
                                </Dropdown.Link>
                            </Dropdown.Content>
                        </Dropdown>
                    </div>
                </div>

                <div className="-mr-2 flex items-center sm:hidden">
                    <button
                        onClick={() => setShowingNavigationDropdown((previousState) => !previousState)}
                        className="inline-flex items-center justify-center p-2 rounded-md text-slate-400 hover:text-slate-500 hover:bg-slate-100 focus:outline-none focus:bg-slate-100 focus:text-slate-500 transition duration-150 ease-in-out"
                    >
                        <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                            <path
                                className={!showingNavigationDropdown ? 'inline-flex' : 'hidden'}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 6h16M4 12h16M4 18h16"
                            />
                            <path
                                className={showingNavigationDropdown ? 'inline-flex' : 'hidden'}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div className={(showingNavigationDropdown ? 'block' : 'hidden') + ' sm:hidden'}>
            <div className="pt-2 pb-3 space-y-1">
                {/* <ResponsiveNavLink href={route('saas.home')} active={route().current('saas.home')}>
                    Dashboard
                </ResponsiveNavLink> */}

            </div>

            <div className="pt-4 pb-1 border-t border-slate-200">
                <div className="px-4">
                    <div className="font-medium text-base text-slate-800">{user.name}</div>
                    <div className="font-medium text-sm text-slate-500">{user.email}</div>
                </div>

                <div className="mt-3 space-y-1">
                    <ResponsiveNavLink href={route('profile.edit')}>Profile</ResponsiveNavLink>
                    <ResponsiveNavLink method="post" href={route('signout')} as="button">
                        Log Out
                    </ResponsiveNavLink>
                </div>
            </div>
        </div>
    </nav>
  )
}

export default NavBar
